import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';

import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatButton } from '@angular/material/button';

import { AccountInfo } from '@azure/msal-browser';

import { GanLucidIcon } from '@gan/shared/ui-icon';

import { LanguageSwitcherComponent } from '../language-switcher/language-switcher.component';
import { DarkModeTogglerComponent } from '@gan/shared/ui-dark-mode-toggler';
import { MenuComponent } from '../menu/menu.component';

@Component({
  selector: 'gan-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MenuComponent,
    DarkModeTogglerComponent,
    LanguageSwitcherComponent,
    MatButton,
    MatMenuTrigger,
    GanLucidIcon,
    MatMenu,
    MatMenuItem,
  ],
})
export class HeaderComponent {
  readonly msAccount = input<AccountInfo | null>(null);

  readonly logout = output<void>();

  onLogout() {
    // TODO: The 'emit' function requires a mandatory void argument
    this.logout.emit();
  }
}
